import store from '../store/index';
import { TABLE_NUM_ITEMS } from '../constants';

const menusGuard = (to, from, next) => {
  store.dispatch('menus/LoadMenus', { offset: 0, limit: TABLE_NUM_ITEMS }).then(() => next());
  store.dispatch('recipes/LoadRecipes', { offset: 0 }).then(() => next());
}

export default menusGuard;